import { io } from "socket.io-client";
// Redux
import store from "../redux/store";
import { fetchGradeApplication } from "../redux/features/gradeApplication/gradeApplicationActions";
import { fetchNotifications } from "../redux/features/notifications/notificationActions";
import { fetchToken } from "../redux/features/login/loginActions";

import { SocketEventNames } from "../app/utils/socketEventNames";
import webConfig from "../web.config.map";
import { enqueueSnackbar } from "../app/hooks/useCommonSnackbar";
import { formatMessage } from "../app/hooks/useCommonIntl";

class SocketService {
    socket = undefined;

    constructor() {
        const NODE_ENV = process.env.NODE_ENV;
        if (NODE_ENV === 'development') {
            // this.socket = io("http://10.0.100.105:7070");
            this.socket = io("http://10.0.100.105:7070", {
                transports: ['websocket']
            });
        }
        else {
            this.socket = io();
        }

        this.socket.on('connect', () => console.log('Socket connection was established.'));
        this.socket.on('connect_error', err => console.error('Socket Connection Error: ', err));

        this.socket.on(SocketEventNames.GRADE_APP_REJECT, data => {
            store.dispatch(fetchGradeApplication(data.id));
            store.dispatch(fetchNotifications(data.id));
            enqueueSnackbar(formatMessage({ id: data.msg }), { variant: 'error' });
        });

        this.socket.on(SocketEventNames.GRADE_APP_ONPROCESS, data => {
            store.dispatch(fetchGradeApplication(data.id));
            store.dispatch(fetchNotifications(data.id));
            enqueueSnackbar(formatMessage({ id: data.msg }), { variant: 'info' });
        });

        this.socket.on(SocketEventNames.GRADE_APP_ACCEPT, data => {
            store.dispatch(fetchGradeApplication(data.id))
            store.dispatch(fetchNotifications(data.id));
            enqueueSnackbar(formatMessage({ id: data.msg }), { variant: 'success' });
        });

        this.socket.on(SocketEventNames.STAKEHOLDER_ACCEPTED, data => {
            store.dispatch(fetchNotifications(data.id));
            store.dispatch(fetchToken({ id: data.id }));
            enqueueSnackbar(formatMessage({ id: data.msg }), { variant: 'success' });
        });
        this.socket.on(SocketEventNames.STAKEHOLDER_REJECTED, data => {
            store.dispatch(fetchNotifications(data.id));
            store.dispatch(fetchToken({ id: data.id }));
            enqueueSnackbar(formatMessage({ id: data.msg }), { variant: 'error' });
        });
        this.socket.on(SocketEventNames.CLASSIFICATION_ACCEPTED, data => {
            store.dispatch(fetchNotifications(data.id));
            store.dispatch(fetchToken({ id: data.id }));
            enqueueSnackbar(formatMessage({ id: data.msg }), { variant: 'success' });
        });
        this.socket.on(SocketEventNames.CLASSIFICATION_REJECTED, data => {
            store.dispatch(fetchNotifications(data.id));
            store.dispatch(fetchToken({ id: data.id }));
            enqueueSnackbar(formatMessage({ id: data.msg }), { variant: 'success' });
        });
        this.socket.on(SocketEventNames.GRADE_APP_AND_CLASSIFICATION_UPDATED, data => {
            store.dispatch(fetchNotifications(data.id));
            enqueueSnackbar(formatMessage({ id: data.msg }), { variant: 'warning', autoHideDuration: 8000 });
        })
    }

    getSocket() {
        return this;
    }

    join(userId) {
        this.socket.emit(SocketEventNames.JOIN, userId);
    }

    emit({ eventName = '', data = '' }) {
        this.socket.emit(eventName, data);
    }

}

export default new SocketService();